import React from 'react';

import * as Misc from "./../../../misc";

export default ({button}) =>
  (
    <div className="message-system-dismiss-button" onClick={e => Misc.ignore(e, () => button.click())}>
      {button.text}
    </div>
  );





// WEBPACK FOOTER //
// ./src/components/common/messageBox/messageBoxButton.js